import React, { useState, useEffect } from "react";
import "./styles/plan.scss";
import { useAuth } from "../../pages/login/AuthProvider";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { backend } from "../../components/apipath";
import { usePayment } from "../../components/PaymentContext";

function Plan() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // 一律以字串處理，避免型別不一致
    const parentId = (queryParams.get("parent_id") || "1");
    const isCPE = String(parentId) === "4";
    const { step, setStep } = usePayment();
    const { authorized } = useAuth();
    const navigate = useNavigate();

    const [productData, setProductData] = useState([]);
    const [selectedCardId, setSelectedCardId] = useState(1);
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined"
        ? window.matchMedia("(max-width: 1200px)").matches
        : false
    );

    // 桌機且 parent_id 為 1 或 6 時使用旋轉木馬
    const isCarousel = !isMobile && ["1", "6"].includes(String(parentId));

    useEffect(() => {
        const mql = window.matchMedia("(max-width: 1200px)");
        const handler = (e) => setIsMobile(e.matches);
        mql.addEventListener("change", handler);
        return () => mql.removeEventListener("change", handler);
    }, []);

    useEffect(() => {
        localStorage.removeItem("selectedPlan");
    }, []);

    const handleSelectPlan = (productId) => {
        setSelectedCardId(productId);
    };

    

    // 通用定位：以 centerIndex 為中心，決定每張卡的相對位置；其餘標記為 off
    const assignPositions = (list, centerIndex = 0) => {
        const total = list.length;
        return list.map((product, index) => {
        const d = (index - centerIndex + total) % total; // 0: 自己, 1: 右, 2: far-right, total-1: 左, total-2: far-left
        let position = "off";
        if (d === 0) position = "center";
        else if (d === 1) position = "right";
        else if (d === 2) position = "far-right";
        else if (d === total - 1) position = "left";
        else if (d === total - 2) position = "far-left";
        return { ...product, position };
        });
    };

    useEffect(() => {
        const fetchData = async () => {
        try {
            const url = `${backend}product/productData?parent_id=${parentId}`;
            const response = await axios.get(url);
            const data = response.data || [];

            let initializedData;
            if (isMobile) {
            // 手機：統一使用簡單直列卡
            initializedData = data.map((p) => ({ ...p, position: "simple" }));
            } else if (isCarousel) {
            // 桌機 + (parent_id = 1 或 6)：旋轉木馬
            initializedData = assignPositions(data, 0);
            } else {
            // 桌機 + 其他 parent：簡單卡片
            initializedData = data.map((p) => ({ ...p, position: "simple" }));
            }

            setProductData(initializedData);
            setSelectedCardId(initializedData[0]?.product_id ?? null);
        } catch (error) {
            console.error("Error:", error);
            setProductData([]);
            setSelectedCardId(null);
        }
        };
        fetchData();
        // isCarousel 依賴 isMobile 與 parentId，放在 deps 內避免舊值
    }, [parentId, isMobile, isCarousel]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleClick = (clickedId) => {
        setSelectedCardId(clickedId);
        const clickedIndex = productData.findIndex(
        (product) => product.product_id === clickedId
        );
        setProductData(assignPositions(productData, clickedIndex));
    };

    const handleNextStepClick = () => {
    if (!authorized) {
        Swal.fire({
        icon: "warning",
        color: "#224040",
        text: "尚未登入會員",
        });
        navigate("../member/memberlogin");
    } else {
        if (selectedCardId) {
        localStorage.setItem("selectedPlan", selectedCardId);
        localStorage.setItem("selectedParentId", parentId);
        setStep(1);
        navigate(
            `../registration?product_id=${selectedCardId}&parent_id=${parentId}`
        );
        } else {
        Swal.fire({
            icon: "warning",
            color: "#224040",
            text: "請選擇一個方案",
        });
        }
    }
    };


    // 舊流程保留（若其他地方有呼叫）
    const handleNextStep = () => {
        if (!authorized) {
        Swal.fire({
            icon: "warning",
            color: "#224040",
            text: "尚未登入會員",
        });
        navigate("../member/memberlogin");
        } else {
        if (selectedCardId) {
            localStorage.setItem("selectedPlan", selectedCardId);
            setStep(1);
            navigate(`../registration`);
        } else {
            Swal.fire({
            icon: "warning",
            color: "#224040",
            text: "請選擇一個方案",
            });
        }
        }
    };

    // 放在 render 前面（或 component 裡面任一處）
    const getColClass = (len, index) => {
    // 基本：手機 1 欄、平板 2 欄、桌機 3 欄
    let cls = "col-xs-12 col-sm-6 col-md-4";

    // 只有 1 張：桌機置中（4格寬，往右推4格）
    if (len === 1 && index === 0) cls += " col-md-offset-4";

    // 只有 2 張：桌機置中（第一張往右推2格）
    if (len === 2 && index === 0) cls += " col-md-offset-2";

    return cls;
    };

    return (
        <>
        <div className="wplan">
            <div className="beckertitlename m-5">請確認購買方案</div>

            {isMobile ? (
            // ✅ 手機：直列卡片（不使用旋轉木馬）
            <div className="container">
                {productData.map((product) => (
                <div
                    key={product.product_id}
                    className={`card pdbox w-100 mb-4 ${
                    selectedCardId === product.product_id ? "selected" : "dimmed"
                    }`}
                    onClick={() => handleSelectPlan(product.product_id)}
                >
                    <h5>{product.name}</h5>
                    <div
                    className="card-body"
                    dangerouslySetInnerHTML={{ __html: product.content }}
                    />
                    <div className="ugbk">
                    <h6>使用效期</h6>
                    <span>{product.exp}</span>
                    {isCPE && (
                        <small className="text-muted d-block mt-1">購買後一週內啟用</small>
                    )}
                    </div>
                    <div className="ugbk">
                    <h6>適用客群</h6>
                    <span>{product.applicable}</span>
                    </div>
                    <div className="cash">{product.price}</div>
                </div>
                ))}

                <div className="nextstep text-center">
                <button className="btn btn-primary mb-5" onClick={handleNextStepClick}>
                    下一步
                </button>
                </div>
            </div>
            ) : (
            // 🖥️ 桌機
            isCarousel ? (
                // —— 旋轉木馬（parent_id = 1 或 6） ——
                <div className="container-fluid">
                <div className="carousel-container">
                    {productData.map((product) => (
                    <div
                        key={product.product_id}
                        className={`carousel-card ${product.position}`}
                        // 為了「可直接覆蓋」無需改 SCSS，也可在這裡隱藏 off
                        style={product.position === "off" ? { display: "none" } : undefined}
                        onClick={() => handleClick(product.product_id)}
                    >
                        <div className="card pdbox planh">
                        <h5>{product.name}</h5>
                        <div
                            className="card-body"
                            dangerouslySetInnerHTML={{ __html: product.content }}
                        />
                        <div className="ugbk">
                        <h6>使用效期</h6>
                        <span>{product.exp}</span>
                        {isCPE && (
                            <small className="text-muted d-block mt-1">購買後一週內啟用</small>
                        )}
                        </div>
                        <div className="ugbk">
                            <h6>適用客群</h6>
                            <span>{product.applicable}</span>
                        </div>
                        <div className="cash">{product.price}</div>
                        </div>
                    </div>
                    ))}
                </div>
                <div className="nextstep text-center">
                    <button className="btn btn-primary mb-3" onClick={handleNextStepClick}>
                    下一步
                    </button>
                </div>
                </div>
            ) : (
                <div className="container mb100">
                    <div className="row">
                        {productData.map((product, idx) => (
                        <div
                            key={product.product_id}
                            className={getColClass(productData.length, idx)}
                        >
                            <div
                            className={`card pdbox h-100 mb-5 ${
                                selectedCardId === product.product_id ? "selected" : "dimmed"
                            }`}
                            onClick={() => handleSelectPlan(product.product_id)}
                            style={{ cursor: "pointer" }}
                            >
                            {/* 內容同你原本 */}
                            </div>
                        </div>
                        ))}
                    </div>

                    <div className="nextstep text-center">
                        <button className="btn btn-primary mb-3" onClick={handleNextStepClick}>
                        下一步
                        </button>
                    </div>
                </div>
            )
            )}
        </div>
        </>
    );
}

export default Plan;
